// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5c71b557","703":"afcf4ccc"}[chunkId] + ".chunk.js";
};